import axiosRequest from "../universal/axiosService";
import { ENDPOINTS } from "../../apiConfig";

export const fetchIncentiveSettingsApi = async (key) => {
  const params = {
    coll: "IncentiveSetting",
    fil: JSON.stringify({ key: { type: "NONE", value: key } }),
  };
  const result = await axiosRequest({
    method: "GET",
    url: ENDPOINTS.INCENTIVE_SETTINGS.GET_BY_KEY,
    params,
  });
  if (!result.success) throw new Error(result.error);
  // Backend returns generic response wrapper, likely the first item if found, or list.
  // We need to handle if it returns an array or single object. 
  // Based on other endpoints, it usually returns a list or object inside `data`.
  return result.data;
};

export const saveIncentiveSettingsApi = async (payload) => {
  // If uiid exists, it's an update.
  const isUpdate = !!payload.uiid;
  
  const endpoint = isUpdate 
    ? ENDPOINTS.INCENTIVE_SETTINGS.UPDATE 
    : ENDPOINTS.INCENTIVE_SETTINGS.ADD;
    
  const method = isUpdate ? "PATCH" : "POST";
  
  const params = {
      coll: "IncentiveSetting",
      ...(isUpdate && { uiid: payload.uiid }),
  };

  // For UPDATE: send ONE single SET operation with an object value
  // buildUpdateData overwrites $set in loop, so we can't have multiple keys with SET
  // Also flattenObject(primitive) fails, so value must be an object
  const apiPayload = isUpdate ? {
    update: { 
      type: "SET", 
      value: {
        quarterlyTarget: payload.quarterlyTarget,
        yearlyTarget: payload.yearlyTarget,
        value: payload.value
      }
    }
  } : payload;

  const data = {
      coll: "IncentiveSetting",
      payload: apiPayload
  };

  const result = await axiosRequest({
    method,
    url: endpoint,
    params: isUpdate ? params : {}, // Update takes query params for ID
    data,
  });
  
  if (!result.success) throw new Error(result.error);
  return result.data;
};

// Patch only value.activeRoles on an existing IncentiveSetting
export const updateActiveRoles = async (settingUiid, activeRoles) => {
  const result = await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.INCENTIVE_SETTINGS.UPDATE,
    params: {
      coll: "IncentiveSetting",
      uiid: settingUiid,
    },
    data: {
      payload: [{
        type: "SET",
        value: { 
          "value.activeRoles": activeRoles,
          _skipFlatten: ["value.activeRoles"]
        }
      }]
    },
  });
  if (!result.success) throw new Error(result.error);
  return result.data;
};
